<template>
  <div>
     <!-- 导航栏 -->
        <div id="headers">
            <img src="../../assets/images/img_31.png" alt="" @click="returnPage" id="returns">
            <div class="headerText">钱大师用户实名认证</div>
        </div>
        <!-- 身份信息 -->
        <div class="content_wrap">
        <div class="input_wrap">
            <h2 class="content_h2 mr_36">姓名</h2>
            <input v-model="Name" type="text" placeholder="请输入您的真实姓名" >
        </div>
        <div class="input_wrap">
            <h2 class="content_h2">身份证号</h2>
            <input v-model="IdCard" type="text" placeholder="请输入您的身份证号" >
        </div>    
    </div>
    <!-- 身份证正反面 -->
      <div class="img_wraps">
        <form action="" enctype="multipart/form-data">
            <input type="file"  @change="changeImg($event,'portrait')" ref="file" id="file" accept="image/*">
            <img id="img_content" class="add" src="../../assets/images/Portrait.png">
        </form>
        <div class="content">点击上传身份证<i>人像面</i></div>
        <form action="" enctype="multipart/form-data">
            <input type="file"  @change="changeImg($event,'national')" ref="files" id="files" accept="image/*">
            <img id="img_contents" class="add" src="../../assets/images/national_emblem.png">
        </form>
        <div class="content">点击上传身份证<i>国徽面</i></div>
    </div>
    <div class="btn" @click="submit">提交</div>
  </div>
</template>

<script>
  import { Dialog } from 'vant';
export default {
data () {
  return {
    Name:'',
    IdCard:'',
    img:'', //人像面地址
    imgs:''//国徽面地址
  }
},
methods: {
  // 返回按钮
    returnPage(){
      this.$router.go(-1);
  },
  // 处理图片 
   changeImg(e,type){
     this.$loading(true);
       if(type==='portrait'){
         var img = document.getElementById("file");
         var fr = new FileReader();
         fr.readAsDataURL(img.files[0]);
         var _this = this;
         fr.onload = function(){
             _this.img = this.result;
            if(_this.sizeImg(_this.img) > 238584) {
              _this.compressImg(_this.img)
            }
             document.getElementById("img_content").setAttribute('src',this.result);     //显示图片
         _this.$loading(false);
         }
       }else if(type==='national') {
         var img = document.getElementById("files");
         var fr = new FileReader();
         fr.readAsDataURL(img.files[0]);
         var _this = this;
         fr.onload = function(){
             _this.imgs = this.result;
            if(_this.sizeImg(_this.imgs) > 238584) {
              _this.compressImg2(_this.imgs)
            }
             document.getElementById("img_contents").setAttribute('src',this.result);     //显示图片
            _this.$loading(false);
          }
        }
      
},
sizeImg(base64) //获取base64字符串的大小
  {
    if (base64) 
    {
      base64=base64.split(",")[1].split("=")[0];
      var strLength = base64.length;
      var fileLength = strLength - (strLength / 8) * 2;
      return Math.floor(fileLength); // 向下取整
    } else {
      return 0;
    }
  }, 
// 封装一个图片压缩函数
compressImg(img_path) {
  var _this = this
    console.log("get in and start compress");
    var img = new Image();
    img.src = img_path;
    img.onload = function(){
        var w = this.width,
            h = this.height,
            scale = w / h;

        //创建canvas
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        canvas.width = w;
        canvas.height = h;
        ctx.drawImage(this, 0, 0, w, h);

        var quality = 0.6;
        var base64_temp = canvas.toDataURL('image/jpeg', quality);
        _this.imgCallback(base64_temp);
    }
},
imgCallback(base64_temp) {
  var _this = this;
  var urlFile = _this.convertBase64UrlToBlob(base64_temp)
  console.log(urlFile.size)
  if(urlFile.size >461104){
    _this.img = false;
    Dialog.alert({
        title: "提示",
        message: "当前图片过大"
      });
  }else{
    _this.img = base64_temp;
  }
},
imgCallback2(base64_temp) {
  var _this = this;
  var urlFile = _this.convertBase64UrlToBlob(base64_temp)
  console.log(urlFile.size)
  if(urlFile.size >461104){
    _this.imgs = false;
    Dialog.alert({
        title: "提示",
        message: "当前图片过大"
      });
  }else{
    _this.imgs = base64_temp;
  }
},
compressImg2(img_path) {
  var _this = this
    console.log("get in and start compress");
    var img = new Image();
    img.src = img_path;
    img.onload = function(){
        var w = this.width,
            h = this.height,
            scale = w / h;

        //创建canvas
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        canvas.width = w;
        canvas.height = h;
        ctx.drawImage(this, 0, 0, w, h);

        var quality = 0.6;
        var base64_temp = canvas.toDataURL('image/jpeg', quality);
        var urlFile = _this.convertBase64UrlToBlob(base64_temp)
        _this.imgCallback2(base64_temp);
    }
},
convertBase64UrlToBlob(urlData) {
    var arr = urlData.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type:mime});
},

  submit(){
    if(this.Name ===''){
      Dialog.alert({
      title: '提示',
      message: '请输入姓名',
      })
      return ;
    }
    if(this.IdCard ===''){
      Dialog.alert({
      title: '提示',
      message: '请输入身份证号码',
      })
      return ;
    }
     if(this.img ==='' || this.imgs ===''){
      Dialog.alert({
      title: '提示',
      message: '请上传证件照',
      })
      return ;
    }
    if(this.imgs ===false || this.img ===false) {
      Dialog.alert({
        title: "提示",
        message: "当前图片过大"
      });
    }
    console.log(this.sizeImg(this.img))
    console.log(this.sizeImg(this.imgs))
     let param = {
      name:this.Name,
      identity  : this.IdCard,
      id_up:this.img,
      id_down:this.imgs
    }
    this.$loading(true);
    this.$http.POSTS('tuser_cash/uploadIdCard',param,(res)=>{
       this.$loading(false);
        if(res.flag === 'error'){
          Dialog.alert({
            title: '提示',
            message: res.msg,
            })
            return ;
        }
    this.$router.push('/mineInformation')})
 }
}
}
</script>

<style lang='less' scoped>
  #headers{
            width: 375px;
            height: 45px;
            background: linear-gradient(to right,#EB3F47,#E50113);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            #returns{
                width: 11px;
                height: 18px;
                position: absolute;
                left: 15px;
                padding: 0 3px;
            }
            .headerText{
                font-size: 15px;
                color: #FFFFFF;
            }
        }
 .content_wrap{
    box-shadow:0px 0px 0px 0px rgba(229,229,229,1);
    margin:15px;
    box-sizing: border-box;
    background: white;
    border-radius:5px;
    overflow: hidden;
    >.input_wrap:nth-child(1){
       border-bottom: 1px solid #E5E5E5;
    }
    .input_wrap{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius:2px;    
    box-sizing: border-box;
    height: 50px;
    h2 {
      margin-left: 15px;
      font-size:16px;
      font-family:PingFangSC-Regular;
      color:rgba(51,51,51,1);
      line-height:16px; 
      width: 70px;;
    }
    input {
      display: inline-block;
      flex: 1;
      background:none;outline:none;appearance:none;
      outline-style: none;
      border: none;
      -moz-appearance:none;
      -webkit-appearance:none;
      height: 50px;
      padding: 0 15px;
      text-align: right;
                font-weight:400;
        color:rgba(21,21,21,1);
        line-height:17px;
    }
    // input::-webkit-input-placeholder{
    //     text-align: right;
    //     }
  }
 }
 .img_wraps {
      display: flex;
      flex-direction: column;
      align-items:center;
      width:345px;
      background:rgba(255,255,255,1);
      box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
      border-radius:5px;
      border:1px solid rgba(222,222,222,1);
      margin: 15px;
      padding-bottom:15px;
      form{
        display: block;
        width: 196px;
        padding: 16px;  
        background-color: #EDEDED;
        position: relative;
        margin-top:15px; 
    }
    form input{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
    }
    form img{
        width: 100%;
        height: 100%;
    }
    .content {
      padding-top:8px;
      font-size:13px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(51,51,51,1);
      line-height:18px;
      i {
        color: #E50113;
        padding-left: 6px;
        font-style:normal;
      }
    }
 }
 .btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height:50px;
  background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
  box-shadow:0px 5px 10px 0px rgba(229,1,19,0.15);
  border-radius:25px;
  margin:32px 20px 48px 20px;
  font-size:15px;
  font-weight:500;
  color:rgba(255,255,255,1);
  line-height:15px;
 }
</style>